import { render } from "./SelectRepresentation.vue?vue&type=template&id=0f20baa9"
import script from "./SelectRepresentation.vue?vue&type=script&lang=js"
export * from "./SelectRepresentation.vue?vue&type=script&lang=js"

import "./SelectRepresentation.vue?vue&type=style&index=0&id=0f20baa9&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__